<template>
  <div v-if="show" class="odp_model">
    <template v-for="(item, index) in table">
      <o-vData
        v-if="item['data']"
        :key="item.id"
        :lineIndex="index"
        :lineData="item"
        :func_input="inputChange"
        :func_click="func_SPEC_S"
      />
      <o-vDataMulti
        v-else-if="item['data_multi']"
        :key="item.id"
        :lineIndex="index"
        :lineData="item"
        :func_input="inputChange"
        :func_click="func_SPEC_S"
      />
      <o-vDataAfter
        v-else-if="item['data_after']"
        :key="item.id"
        :lineIndex="index"
        :lineData="item"
        :func_input="inputChange"
        :func_click="func_SPEC_S"
      />
    </template>
  </div>
</template>
<script>
import { gain_produce } from '@/seal/proRedEnvelopes';

export default {
  name: 'hebanhongbao', //合版红包
  components: {},
  props: {},
  data() {
    return {
      pidd: 'pidredenv_hbhb',
      pid: 'pidredenv_hbhb',
      show: false,
      table: {},
    };
  },
  methods: {
    showChange() {
      // 获取表单
      const produce = gain_produce(this['pid']);
      if (produce['table']) {
        this.table = produce['table'];
      } else {
        return;
      }

      this.show = true;
    },
    closeChange() {
      this.show = false;
    },
    //输入框完成事件
    inputChange(event) {
      const params = this.func_tidyParams();
      this.$parent.func_quotation(this.pidd, params);
    },
    //点击产品规格-汇总
    func_SPEC_S(event) {
      const type = event.currentTarget.dataset.type;
      const index = event.currentTarget.dataset.index;
      const seq = event.currentTarget.dataset.seq;
      if (!this.table[index] || !this.table[index][type]) return;
      switch (type) {
        case 'data': {
          //当前点击行的所有参数规格
          console.log()
          let data = this.table[index][type];
          if (data[seq]['name'] == '自定义展开尺寸') {
            this.table['p_daomo'] = {
              name: '刀模',
              container: 'daomo',
              data: [
                {
                  type: 'default',
                  name: '定制刀模',
                  value: '1',
                  choose: true,
                },
              ],
            };
          } else if ((data[seq]['name'] === '大号(88*165)' || data[seq]['name'] === '小号(80*120)') &&!this.table['p_leixing'].data[2].choose) {
            this.table['p_daomo'] = {
              name: '刀模',
              container: 'daomo',
              data: [
                {
                  type: 'default',
                  name: '标准-元宝舌',
                  value: '0',
                  choose: true,
                },
                {
                  type: 'default',
                  name: '标准-圆舌',
                  value: '0',
                  choose: false,
                },
              ],
            };
          }
          if (
            data[seq]['name'].indexOf('标准') >= 0 &&
            !this.table['p_chengpinchicun']['data'][0].choose &&
            !this.table['p_chengpinchicun']['data'][1].choose
          ) {
            this.table['p_chengpinchicun']['data'] = [
              {
                type: 'default',
                name: '大号(88*165)',
                value: [187, 215, '大号(88*165)'],
                choose: true,
              },
              {
                type: 'default',
                name: '小号(80*120)',
                value: [171, 162, '中号(80*120)'],
                choose: false,
              },
              {
                type: 'custom2',
                name: '自定义展开尺寸',
                value: [195, 205, '展开尺寸:195×205', '195*205', '1'],
                choose: false,
              },
            ];
            this.table['p_daomo'] = {
              name: '刀模',
              container: 'daomo',
              data: [
                {
                  type: 'default',
                  name: '标准-元宝舌',
                  value: '0',
                  choose: true,
                },
                {
                  type: 'default',
                  name: '标准-圆舌',
                  value: '0',
                  choose: false,
                },
              ],
            };
          }
          if (data[seq]['name'] === '彩印红包') {
            (this.table['p_yinshuashuliang'] = {
              name: '印刷数量',
              container: 'shuliang',
              data: [
                { type: 'default', name: '1000', value: 1000, choose: true },
                { type: 'default', name: '2000', value: 2000, choose: false },
                { type: 'default', name: '3000', value: 3000, choose: false },
                { type: 'default', name: '5000', value: 5000, choose: false },
                { type: 'default', name: '10000', value: 10000, choose: false },
                { type: 'default', name: '20000', value: 20000, choose: false },
                { type: 'custom1', name: '', value: 20000, choose: false },
              ],
            }),
              (this.table['p_daomo'] = {
                name: '刀模',
                container: 'daomo',
                data: [
                  {
                    type: 'default',
                    name: '标准-元宝舌',
                    value: '0',
                    choose: true,
                  },
                  {
                    type: 'default',
                    name: '标准-圆舌',
                    value: '0',
                    choose: false,
                  }
                ],
              }),
              (this.table['p_chengpinchicun']['data'] = [
                {
                  type: 'default',
                  name: '大号(88*165)',
                  value: [187, 215, '大号(88*165)'],
                  choose: true,
                },
                {
                  type: 'default',
                  name: '小号(80*120)',
                  value: [171, 162, '中号(80*120)'],
                  choose: false,
                },
                {
                  type: 'custom2',
                  name: '自定义展开尺寸',
                  value: [195, 205, '展开尺寸:195×205', '195*205', '1'],
                  choose: false,
                },
              ]);
            this.table['p_zhizhangkezhong'] = {
              name: '纸张克重',
              container: ['cailiao', 'yongzhi'],
              data_multi: [
                {
                  type: 'select',
                  name: '双铜纸',
                  value: '1',
                  choose: true,
                  level: '1',
                  select_show: false,
                  select_data: [
                    { name: '双铜纸', value: '1' },
                    { name: '单铜纸(白卡纸)', value: '2' },
                    { name: '红包艺术纸', value: '20350' },
                    { name: '单面珠光冰白', value: '20579' },
                  ],
                },
                {
                  type: 'select',
                  name: '157克',
                  value: '157',
                  choose: true,
                  level: '2',
                  select_show: false,
                  select_data: [
                    { name: '157克', value: 157 },
                    { name: '200克', value: 200 },
                    // { name: "250克", value: 250 },
                  ],
                },
              ],
              multi_list: [
                // 双铜纸
                [
                  { name: '157克', value: 157 },
                  { name: '200克', value: 200 },
                ],
                [{ name: '215克', value: '210' }],
                [{ name: '150克', value: '150' }],
                [{ name: '160克', value: '160' }],
              ],
            };
            this.table['p_yinshuayanse'] = {
              name: '印刷颜色',
              container: 'ysys',
              data: [
                { type: 'default', name: '彩色', value: '4', choose: true },
                // { type: "default", name: "无", value: "0", choose: false },
              ],
            };
            this.table['p_houdaogongxu'] = {
              name: '后道工序',
              data_after: [
                {
                  container: 'bmcl',
                  must: false,
                  data: [
                    {
                      type: 'select',
                      name: '单面哑膜',
                      value: '8657',
                      choose: true,
                      select_show: false,
                      select_data: [
                        { name: '单面亮膜', value: '8656' },
                        { name: '单面哑膜', value: '8657' },
                        { name: '单面触感膜', value: '4292' },
                        { name: '单面防刮花哑膜', value: '防刮花哑膜' },
                      ],
                    },
                  ],
                },
                {
                  container: 'hjgzdy0',
                  must: false,
                  reduce: false,
                  data: [
                    {
                      type: 'default',
                      name: '过光油',
                      value: '4217',
                      choose: false,
                    },
                  ],
                },
                {
                  container: ['tjx', 'tjy', 'tangCl', 'hjg'],
                  must: false,
                  data: [
                    {
                      type: 'select',
                      custom2: true,
                      unit: 'mm',
                      name: '普通平烫',
                      value: ['150', '150', '25552', '烫金'],
                      choose: false,
                      select_show: false,
                      select_data: [
                        {
                          name: '普通平烫',
                          value: ['150', '150', '25552', '烫金'],
                        },
                        {
                          name: '浮雕烫',
                          value: ['150', '150', '25551', '烫金'],
                        },
                      ],
                    },
                  ],
                },
                {
                  container: 'tjys',
                  must: false,
                  data: [
                    {
                      type: 'select',
                      name: '烫黄金',
                      value: '烫金',
                      choose: false,
                      select_show: false,
                      select_data: [
                        { name: '烫黄金', value: '烫金' },
                        { name: '烫哑金', value: '烫金' },
                        { name: '烫红金', value: '烫金' },
                        { name: '烫蓝金', value: '烫金' },
                        { name: '烫黑金', value: '烫金' },
                        { name: '烫银', value: '烫金' },
                        { name: '烫特殊颜色金', value: '烫金' },
                      ],
                    },
                  ],
                },
                {
                  container: ['jtx', 'jty', 'hjg', 'jtCl'],
                  must: false,
                  data: [
                    {
                      type: 'select',
                      custom2: true,
                      unit: 'mm',
                      name: '普通击凸版',
                      value: [120, 120, '击凸', '25548'],
                      choose: false,
                      select_show: false,
                      select_data: [
                        {
                          name: '普通击凸版',
                          value: [120, 120, '击凸', '25548'],
                        },
                        {
                          name: '加厚击凸版',
                          value: [120, 120, '击凸', '25549'],
                        },
                      ],
                    },
                  ],
                },
                {
                  container: 'hjg',
                  must: true,
                  reduce: true,
                  data: [
                    {
                      type: 'default',
                      name: '模切',
                      value: '模切',
                      choose: true,
                    },
                  ],
                },
                {
                  container: 'hjg',
                  must: true,
                  data: [
                    {
                      type: 'default',
                      name: '粘',
                      value: '粘成品',
                      choose: true,
                    },
                  ],
                },
                {
                  container: ['jdgs', 'hjg'],
                  must: false,
                  data: [
                    {
                      type: 'select',
                      name: '装胶袋-10个(一袋)',
                      value: ['10', '装胶袋'],
                      choose: false,
                      select_show: false,
                      select_data: [
                        { name: '装胶袋-5个(一袋)', value: [5, '装胶袋'] },
                        { name: '装胶袋-6个(一袋)', value: [6, '装胶袋'] },
                        { name: '装胶袋-8个(一袋)', value: [8, '装胶袋'] },
                        { name: '装胶袋-10个(一袋)', value: [10, '装胶袋'] },
                      ],
                    },
                  ],
                },
                {
                  container: 'zhzd',
                  must: false,
                  data: [
                    {
                      type: 'select',
                      name: '扎红纸带-100个/扎',
                      value: '100',
                      choose: false,
                      select_show: false,
                      select_data: [
                        {
                          name: '扎红纸带-100个/扎',
                          value: '100',
                        },
                        { name: '扎红纸带-50个/扎', value: '50' },
                      ],
                    },
                  ],
                },
              ],
            };
          } else if (data[seq]['name'] === '特种纸烫金红包') {
            this.table['p_yinshuashuliang'] = {
              name: '印刷数量',
              container: 'shuliang',
              data: [
                { type: 'default', name: '1000', value: 1000, choose: true },
                { type: 'default', name: '2000', value: 2000, choose: false },
                { type: 'default', name: '3000', value: 3000, choose: false },
                { type: 'default', name: '5000', value: 5000, choose: false },
                { type: 'default', name: '10000', value: 10000, choose: false },
                { type: 'default', name: '20000', value: 20000, choose: false },
                { type: 'custom1', name: '', value: 20000, choose: false },
              ],
            },
              this.table['p_daomo'] = {
                name: '刀模',
                container: 'daomo',
                data: [
                  {
                    type: 'default',
                    name: '标准-元宝舌',
                    value: '0',
                    choose: true,
                  },
                  {
                    type: 'default',
                    name: '标准-圆舌',
                    value: '0',
                    choose: false,
                  },
                ],
              },
              this.table['p_chengpinchicun']['data'] = [
                {
                  type: 'default',
                  name: '大号(88*165)',
                  value: [187, 215, '大号(88*165)'],
                  choose: true,
                },
                {
                  type: 'default',
                  name: '小号(80*120)',
                  value: [171, 162, '中号(80*120)'],
                  choose: false,
                },
                {
                  type: 'custom2',
                  name: '自定义展开尺寸',
                  value: [195, 205, '展开尺寸:195×205', '195*205', '1'],
                  choose: false,
                },
              ];
            this.table['p_zhizhangkezhong'] = {
              name: '纸张克重',
              container: ['cailiao', 'yongzhi'],
              data_multi: [
                {
                  type: 'select',
                  name: '闪红',
                  value: '11852',
                  choose: true,
                  level: '1',
                  select_show: false,
                  select_data: [
                    { name: '闪红', value: '11852' },
                    { name: '艳红', value: '11853' },
                    { name: '艳闪', value: '11854' },
                    { name: '红卡', value: '17705' },
                    { name: '触感红', value: '17707' },
                    { name: '红银星点', value: '20347' },
                    { name: '暗红金葱', value: '44447' },
                    { name: '大红珠光', value: '20349' },
                    { name: '大红金点', value: '23167' },
                  ],
                },
                {
                  type: 'select',
                  name: '160克',
                  value: '160',
                  choose: true,
                  level: '2',
                  select_show: false,
                  select_data: [
                    { name: '160克', value: 160 },
                    { name: '120克', value: 120 },
                  ],
                },
              ],

              multi_list: [
                //闪红
                [
                  { name: '160克', value: '160' },
                  { name: '120克', value: '120' },
                ],
                //艳红
                [
                  { name: '160克', value: '160' },
                  { name: '120克', value: '120' },
                ],
                //艳闪
                [
                  { name: '160克', value: '160' },
                  { name: '120克', value: '120' },
                ],
                [{ name: '150克', value: '120' }],
                [{ name: '160克', value: '160' }],
                [{ name: '160克', value: '160' }],
                [{ name: '215克', value: '160' }],
                [{ name: '160克', value: '160' }],
                [{ name: '160克', value: '160' }],
              ],
            };
            this.table['p_yinshuayanse'] = {
              name: '印刷颜色',
              container: 'ysys',
              data: [
                { type: 'default', name: '无', value: '0', choose: true },
                { type: 'default', name: '单色', value: '1', choose: false },
              ],
            };
            this.table['p_houdaogongxu']['data_after'] = [
              {
                container: ['tangCl', 'hjg'],
                must: false,
                data: [
                  {
                    type: 'select',
                    custom: true,
                    name: '普通平烫',
                    value: ['25552', '烫金'],
                    choose: true,
                    select_show: false,
                    select_data: [
                      {
                        name: '普通平烫',
                        value: ['25552', '烫金'],
                      },
                    ],
                  },
                ],
              },
              {
                container: 'tjys',
                must: false,
                data: [
                  {
                    type: 'select',
                    name: '烫黄金',
                    value: '烫金',
                    choose: true,
                    select_show: false,
                    select_data: [
                      { name: '烫黄金', value: '烫金' },
                      { name: '烫哑金', value: '烫金' },
                      { name: '烫红金', value: '烫金' },
                      { name: '烫蓝金', value: '烫金' },
                      { name: '烫黑金', value: '烫金' },
                      { name: '烫银', value: '烫金' },
                      { name: '烫特殊颜色金', value: '烫金' },
                    ],
                  },
                ],
              },
              {
                container: ['tjx', 'tjy', 'tangCl', 'hjg'],
                must: false,
                data: [
                  {
                    type: 'select',
                    custom2: true,
                    unit: 'mm',
                    name: '浮雕烫',
                    value: ['150', '150', '25551', '烫金'],
                    choose: false,
                    select_show: false,
                    select_data: [
                      {
                        name: '浮雕烫',
                        value: ['150', '150', '25551', '烫金'],
                      },
                    ],
                  },
                ],
              },
              {
                container: 'tjys1',
                must: false,
                data: [
                  {
                    type: 'select',
                    name: '烫黄金',
                    value: '烫金',
                    choose: false,
                    select_show: false,
                    select_data: [
                      { name: '烫黄金', value: '烫金' },
                      { name: '烫哑金', value: '烫金' },
                      { name: '烫红金', value: '烫金' },
                      { name: '烫蓝金', value: '烫金' },
                      { name: '烫黑金', value: '烫金' },
                      { name: '烫银', value: '烫金' },
                      { name: '烫特殊颜色金', value: '烫金' },
                    ],
                  },
                ],
              },
              {
                container: ['jtx', 'jty', 'hjg', 'jtCl'],
                must: false,
                data: [
                  {
                    type: 'select',
                    custom2: true,
                    unit: 'mm',
                    name: '普通击凸版',
                    value: [120, 120, '击凸', '25548'],
                    choose: false,
                    select_show: false,
                    select_data: [
                      {
                        name: '普通击凸版',
                        value: [120, 120, '击凸', '25548'],
                      },
                      {
                        name: '加厚击凸版',
                        value: [120, 120, '击凸', '25549'],
                      },
                    ],
                  },
                ],
              },
              {
                container: 'hjg',
                must: true,
                reduce: true,
                data: [
                  {
                    type: 'default',
                    name: '模切',
                    value: '模切',
                    choose: true,
                  },
                ],
              },
              {
                container: 'hjg',
                must: true,
                data: [
                  {
                    type: 'default',
                    name: '粘',
                    value: '粘成品',
                    choose: true,
                  },
                ],
              },
              {
                container: ['jdgs', 'hjg'],
                must: false,
                data: [
                  {
                    type: 'select',
                    name: '装胶袋-10个(一袋)',
                    value: ['10', '装胶袋'],
                    choose: false,
                    select_show: false,
                    select_data: [
                      { name: '装胶袋-5个(一袋)', value: [5, '装胶袋'] },
                      { name: '装胶袋-6个(一袋)', value: [6, '装胶袋'] },
                      { name: '装胶袋-8个(一袋)', value: [8, '装胶袋'] },
                      { name: '装胶袋-10个(一袋)', value: [10, '装胶袋'] },
                    ],
                  },
                ],
              },
              {
                container: 'zhzd',
                must: false,
                data: [
                  {
                    type: 'select',
                    name: '扎红纸带-100个/扎',
                    value: '100',
                    choose: false,
                    select_show: false,
                    select_data: [
                      { name: '扎红纸带-100个/扎', value: '100' },
                      { name: '扎红纸带-50个/扎', value: '50' },
                    ],
                  },
                ],
              },
            ];
          } else if (data[seq]['name'] === '现货红包') {
            (this.table['p_yinshuashuliang'] = {
              name: '印刷数量',
              container: 'shuliang',
              data: [
                { type: 'default', name: '100', value: 100, choose: true },
                { type: 'default', name: '1000', value: 1000, choose: false },
                { type: 'default', name: '2000', value: 2000, choose: false },
                { type: 'default', name: '3000', value: 3000, choose: false },
                { type: 'default', name: '5000', value: 5000, choose: false },
                { type: 'default', name: '10000', value: 10000, choose: false },
                { type: 'custom1', name: '', value: 20000, choose: false },
              ],
            }),
              (this.table['p_yinshuayanse'] = {
                name: '印刷颜色',
                container: 'ysys',
                data: [
                  { type: 'default', name: '无', value: '0', choose: true },
                ],
              });
            (this.table['p_daomo'] = {
              name: '系列',
              container: 'daomo',
              data: [
                { type: 'default', name: '艳闪系列', value: '0', choose: true },
                {
                  type: 'default',
                  name: '金葱纸系列',
                  value: '0',
                  choose: false,
                },
              ],
            }),
              (this.table['p_chengpinchicun']['data'] = [
                {
                  type: 'default',
                  name: '大号(88*165)',
                  value: [187, 215, '大号(88*165)'],
                  choose: true,
                },
                {
                  type: 'default',
                  name: '小号(80*120)',
                  value: [171, 162, '中号(80*120)'],
                  choose: false,
                },
              ]);
            this.table['p_zhizhangkezhong'] = {
              name: '款式',
              container: 'cailiao',
              must: false,
              data: [
                {
                  type: 'select',
                  name: 'L01',
                  value: '大号01-万事如意',
                  choose: true,
                  select_show: false,
                  select_data: [
                    { name: 'L01', value: '大号01-万事如意', src: 1 },
                    { name: 'L02', value: '大号01-万事如意', src: 2 },
                    { name: 'L03', value: '大号01-万事如意', src: 3 },
                    { name: 'L04', value: '大号01-万事如意', src: 4 },
                    { name: 'L05', value: '大号01-万事如意', src: 5 },
                    { name: 'L06', value: '大号01-万事如意', src: 6 },
                  ],
                },
              ],
            };
            this.table['p_houdaogongxu']['data_after'] = [
              {
                container: 'hjg',
                must: false,
                data: [
                  {
                    type: 'select',
                    name: '单面加LOGO',
                    value: '单面加LOGO',
                    choose: true,
                    select_show: false,
                    select_data: [
                      { name: '单面加LOGO', value: '单面加LOGO' },
                      { name: '双面加LOGO', value: '双面加LOGO' },
                    ],
                  },
                ],
              },
              {
                container: 'tjys',
                must: false,
                data: [
                  {
                    type: 'select',
                    name: '烫哑金',
                    value: '烫金',
                    choose: true,
                    select_show: false,
                    select_data: [
                      { name: '烫哑金', value: '烫金' },
                      { name: '烫黄金', value: '烫金' },
                      { name: '烫银', value: '烫金' },
                      { name: '烫红金', value: '烫金' },
                      { name: '烫蓝金', value: '烫金' },
                      { name: '烫黑金', value: '烫金' },
                    ],
                  },
                ],
              },
              {
                container: ['jdgs', 'hjg'],
                must: false,
                data: [
                  {
                    type: 'select',
                    name: '装胶袋-10个(一袋)',
                    value: ['10', '装胶袋'],
                    choose: false,
                    select_show: false,
                    select_data: [
                      { name: '装胶袋-5个(一袋)', value: [5, '装胶袋'] },
                      { name: '装胶袋-6个(一袋)', value: [6, '装胶袋'] },
                      { name: '装胶袋-8个(一袋)', value: [8, '装胶袋'] },
                      { name: '装胶袋-10个(一袋)', value: [10, '装胶袋'] },
                    ],
                  },
                ],
              },
            ];
          }
          if (this.table['p_leixing']['data'][2].choose) {
            if (
              data[seq]['name'] === '大号(88*165)' &&
              this.table['p_daomo']['data'][0].choose
            ) {
              this.table['p_zhizhangkezhong'] = {
                name: '款式',
                container: 'cailiao',
                must: false,
                data: [
                  {
                    type: 'select',
                    name: 'L01',
                    value: '大号01-万事如意',
                    choose: true,
                    select_show: false,
                    select_data: [
                      { name: 'L01', value: '大号01-万事如意', src: 1 },
                      { name: 'L02', value: '大号01-万事如意', src: 2 },
                      { name: 'L03', value: '大号01-万事如意', src: 3 },
                      { name: 'L04', value: '大号01-万事如意', src: 4 },
                      { name: 'L05', value: '大号01-万事如意', src: 5 },
                      { name: 'L06', value: '大号01-万事如意', src: 6 },
                    ],
                  },
                ],
              };
              this.$parent.func_picture1(1);
            } else if (
              data[seq]['name'] === '小号(80*120)' &&
              this.table['p_daomo']['data'][0].choose
            ) {
              this.table['p_zhizhangkezhong'] = {
                name: '款式',
                container: 'cailiao',
                must: false,
                data: [
                  {
                    type: 'select',
                    name: 'S01',
                    value: '小号01-万事如意',
                    choose: true,
                    select_show: false,
                    select_data: [
                      { name: 'S01', value: '小号01-万事如意', src: 7 },
                      { name: 'S02', value: '小号01-万事如意', src: 8 },
                      { name: 'S03', value: '小号01-万事如意', src: 9 },
                      { name: 'S04', value: '小号01-万事如意', src: 10 },
                      { name: 'S05', value: '小号01-万事如意', src: 11 },
                      { name: 'S06', value: '小号01-万事如意', src: 12 },
                    ],
                  },
                ],
              };
              this.$parent.func_picture1(7);
            } else if (
              data[seq]['name'] === '大号(88*165)' &&
              this.table['p_daomo']['data'][1].choose
            ) {
              this.table['p_zhizhangkezhong'] = {
                name: '款式',
                container: 'cailiao',
                must: false,
                data: [
                  {
                    type: 'select',
                    name: 'ML01',
                    value: '大号02-福',
                    choose: true,
                    select_show: false,
                    select_data: [
                      { name: 'ML01', value: '大号02-福', src: 13 },
                      { name: 'ML02', value: '大号02-福', src: 14 },
                      { name: 'ML03', value: '大号02-福', src: 15 },
                      { name: 'ML04', value: '大号02-福', src: 16 },
                      { name: 'ML05', value: '大号02-福', src: 17 },
                      { name: 'ML06', value: '大号02-福', src: 18 },
                    ],
                  },
                ],
              };
              this.$parent.func_picture1(13);
            } else if (
              data[seq]['name'] === '小号(80*120)' &&
              this.table['p_daomo']['data'][1].choose
            ) {
              this.table['p_zhizhangkezhong'] = {
                name: '款式',
                container: 'cailiao',
                must: false,
                data: [
                  {
                    type: 'select',
                    name: 'MS01',
                    value: '小号02-福',
                    choose: true,
                    select_show: false,
                    select_data: [
                      { name: 'MS01', value: '小号02-福', src: 19 },
                      { name: 'MS02', value: '小号02-福', src: 20 },
                      { name: 'MS03', value: '小号02-福', src: 21 },
                      { name: 'MS04', value: '小号02-福', src: 22 },
                      { name: 'MS05', value: '小号02-福', src: 23 },
                      { name: 'MS06', value: '小号02-福', src: 24 },
                    ],
                  },
                ],
              };
              this.$parent.func_picture1(19);
            } else if (
              data[seq]['name'] === '艳闪系列' &&
              this.table['p_chengpinchicun']['data'][0].choose
            ) {
              this.table['p_zhizhangkezhong'] = {
                name: '款式',
                container: 'cailiao',
                must: false,
                data: [
                  {
                    type: 'select',
                    name: 'L01',
                    value: '大号01-万事如意',
                    choose: true,
                    select_show: false,
                    select_data: [
                      { name: 'L01', value: '大号01-万事如意', src: 1 },
                      { name: 'L02', value: '大号01-万事如意', src: 2 },
                      { name: 'L03', value: '大号01-万事如意', src: 3 },
                      { name: 'L04', value: '大号01-万事如意', src: 4 },
                      { name: 'L05', value: '大号01-万事如意', src: 5 },
                      { name: 'L06', value: '大号01-万事如意', src: 6 },
                    ],
                  },
                ],
              };
              this.$parent.func_picture1(1);
            } else if (
              data[seq]['name'] === '艳闪系列' &&
              this.table['p_chengpinchicun']['data'][1].choose
            ) {
              this.table['p_zhizhangkezhong'] = {
                name: '款式',
                container: 'cailiao',
                must: false,
                data: [
                  {
                    type: 'select',
                    name: 'S01',
                    value: '小号01-万事如意',
                    choose: true,
                    select_show: false,
                    select_data: [
                      { name: 'S01', value: '小号01-万事如意', src: 7 },
                      { name: 'S02', value: '小号01-万事如意', src: 8 },
                      { name: 'S03', value: '小号01-万事如意', src: 9 },
                      { name: 'S04', value: '小号01-万事如意', src: 10 },
                      { name: 'S05', value: '小号01-万事如意', src: 11 },
                      { name: 'S06', value: '小号01-万事如意', src: 12 },
                    ],
                  },
                ],
              };
              this.$parent.func_picture1(7);
            } else if (
              data[seq]['name'] === '金葱纸系列' &&
              this.table['p_chengpinchicun']['data'][0].choose
            ) {
              this.table['p_zhizhangkezhong'] = {
                name: '款式',
                container: 'cailiao',
                must: false,
                data: [
                  {
                    type: 'select',
                    name: 'ML01',
                    value: '大号02-福',
                    choose: true,
                    select_show: false,
                    select_data: [
                      { name: 'ML01', value: '大号02-福', src: 13 },
                      { name: 'ML02', value: '大号02-福', src: 14 },
                      { name: 'ML03', value: '大号02-福', src: 15 },
                      { name: 'ML04', value: '大号02-福', src: 16 },
                      { name: 'ML05', value: '大号02-福', src: 17 },
                      { name: 'ML06', value: '大号02-福', src: 18 },
                    ],
                  },
                ],
              };
              this.$parent.func_picture1(13);
            } else if (
              data[seq]['name'] === '金葱纸系列' &&
              this.table['p_chengpinchicun']['data'][1].choose
            ) {
              this.table['p_zhizhangkezhong'] = {
                name: '款式',
                container: 'cailiao',
                must: false,
                data: [
                  {
                    type: 'select',
                    name: 'MS01',
                    value: '小号02-福',
                    choose: true,
                    select_show: false,
                    select_data: [
                      { name: 'MS01', value: '小号02-福', src: 19 },
                      { name: 'MS02', value: '小号02-福', src: 20 },
                      { name: 'MS03', value: '小号02-福', src: 21 },
                      { name: 'MS04', value: '小号02-福', src: 22 },
                      { name: 'MS05', value: '小号02-福', src: 23 },
                      { name: 'MS06', value: '小号02-福', src: 24 },
                    ],
                  },
                ],
              };
              this.$parent.func_picture1(19);
            }
          }

          if (data[seq]['name'] == '现货红包') {
            this.$parent.func_picture1(1);
          } else if (data[seq]['name'] == '彩印红包') {
            this.$parent.func_picture1(25);
          } else if (data[seq]['name'] == '特种纸烫金红包') {
            this.$parent.func_picture1(26);
          } else if (
            this.table.p_daomo.data.length == 1 &&
            data[seq]['name'] == '小号(80*120)'
          ) {
            this.$parent.func_picture1(7);
          } else if (
            this.table.p_daomo.data.length == 1 &&
            data[seq]['name'] == '大号(88*165)'
          ) {
            this.$parent.func_picture1(1);
          }
          if (data[seq]['choose'] && data[seq]['type'] !== 'select') return;

          // 点击区域属-'下拉框'
          if (data[seq]['type'] === 'select') {
            const select_index = event.currentTarget.dataset.select_index;
            if (select_index) {
              data[seq]['name'] =
                data[seq]['select_data'][select_index]['name'];
              data[seq]['value'] =
                data[seq]['select_data'][select_index]['value'];
            }
            if (
              data[seq].select_data &&
              data[seq].select_data[select_index]['src']
            ) {
              this.$parent.func_picture1(
                data[seq]['select_data'][select_index]['src']
              );
            } else {
              this.$parent.func_picture1(13);
            }
          }
          // 切换已选中的'下拉框'的内容时-不需要执行
          if (!data[seq]['choose']) {
            for (let i in data) {
              if (data[i]['choose']) {
                data[i]['choose'] = false;
                data[seq]['choose'] = true;
                break;
              }
            }
          }

          break;
        }
        case 'data_multi': {
          const level = event.currentTarget.dataset.level;
          const select_index = event.currentTarget.dataset.select_index;
          let data = this.table[index][type];
          if (!level) return;

          data[seq]['name'] = data[seq]['select_data'][select_index]['name'];
          data[seq]['value'] = data[seq]['select_data'][select_index]['value'];
          if (level === '1') {
            // 切换二级内容
            data[1]['select_data'] =
              this.table[index]['multi_list'][select_index];
            data[1]['name'] = data[1]['select_data'][0]['name'];
            data[1]['value'] = data[1]['select_data'][0]['value'];

            // 另行处理
            if (index === 'p_zhizhangkezhong') {
              if (
                data[seq]['name'] === '红包艺术纸' ||
                data[seq]['name'] === '单面珠光冰白'
              ) {
                this.table['p_houdaogongxu']['data_after'] = [
                  {
                    container: 'hjgzdy0',
                    must: false,
                    reduce: false,
                    data: [
                      { type: 'default', name: '过光油', value: '4217', choose: false },
                    ]
                  },
                  {
                    container: ['tjx', 'tjy', 'tangCl', 'hjg'],
                    must: false,
                    data: [
                      {
                        type: 'select',
                        custom2: true,
                        unit: 'mm',
                        name: '普通平烫',
                        value: [150, 150, '25552', '烫金'],
                        choose: false,
                        select_show: false,
                        select_data: [
                          {
                            name: '普通平烫',
                            value: [150, 150, '25552', '烫金'],
                          },
                          {
                            name: '浮雕烫',
                            value: [150, 150, '25551', '烫金'],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    container: 'tjys',
                    must: false,
                    data: [
                      {
                        type: 'select', name: '烫黄金', value: '烫金', choose: false, select_show: false, select_data: [
                          { name: '烫黄金', value: '烫金' },
                          { name: '烫哑金', value: '烫金' },
                          { name: '烫红金', value: '烫金' },
                          { name: '烫蓝金', value: '烫金' },
                          { name: '烫黑金', value: '烫金' },
                          { name: '烫银', value: '烫金' },
                          { name: '烫特殊颜色金', value: '烫金' },
                        ]
                      }
                    ]
                  },
                  {
                    container: ['jtx', 'jty', 'hjg', 'jtCl'],
                    must: false,
                    data: [
                      {
                        type: 'select',
                        custom2: true,
                        unit: 'mm',
                        name: '普通击凸版',
                        value: [120, 120, '击凸', '25548'],
                        choose: false,
                        select_show: false,
                        select_data: [
                          { name: '普通击凸版', value: [120, 120, '击凸', '25548'], },
                          { name: '加厚击凸版', value: [120, 120, '击凸', '25549'], },
                        ],
                      },
                    ],
                  },
                  {
                    container: 'hjg',
                    must: true,
                    reduce: true,
                    data: [
                      { type: 'default', name: '模切', value: '模切', choose: true },
                    ]
                  },
                  {
                    container: 'hjg',
                    must: true,
                    data: [
                      { type: 'default', name: '粘', value: '粘成品', choose: true },
                    ]
                  },
                  {
                    container: ['jdgs', 'hjg'],
                    must: false,
                    data: [
                      {
                        type: 'select', name: '装胶袋-10个(一袋)', value: ['10', '装胶袋'], choose: false, select_show: false, select_data: [

                          { name: '装胶袋-5个(一袋)', value: [5, '装胶袋'] },
                          { name: '装胶袋-6个(一袋)', value: [6, '装胶袋'] },
                          { name: '装胶袋-8个(一袋)', value: [8, '装胶袋'] },
                          { name: '装胶袋-10个(一袋)', value: [10, '装胶袋'] },
                        ]
                      },
                    ]
                  },
                  {
                    container: 'zhzd',
                    must: false,
                    data: [
                      {
                        type: 'select',
                        name: '扎红纸带-100个/扎',
                        value: '扎红纸带-100个/扎',
                        choose: false,
                        select_show: false,
                        select_data: [
                          { name: '扎红纸带-100个/扎', value: '100' },
                          { name: '扎红纸带-50个/扎', value: '50' },
                        ],
                      },
                    ]
                  },
                ];
              } else if (data[seq]['name'] === '双铜纸'|| data[seq]['name'] === '单铜纸(白卡纸)') {
                this.table['p_houdaogongxu']['data_after'] = [
                            {
                      container: 'bmcl',
                      must: false,
                      data: [
                        {
                          type: 'select',
                          name: '单面哑膜',
                          value: '8657',
                          choose: true,
                          select_show: false,
                          select_data: [
                            { name: '单面亮膜', value: '8656' },
                            { name: '单面哑膜', value: '8657' },
                            { name: '单面触感膜', value: '4292' },
                            { name: '单面防刮花哑膜', value: '防刮花哑膜' },
                          ],
                        },
                      ],
                    },
                    {
                      container: 'hjgzdy0',
                      must: false,
                      reduce: false,
                      data: [
                        { type: 'default', name: '过光油', value: '4217', choose: false },
                      ]
                    },
                    {
                      container: ['tjx', 'tjy', 'tangCl', 'hjg'],
                      must: false,
                      data: [
                        {
                          type: 'select',
                          custom2: true,
                          unit: 'mm',
                          name: '普通平烫',
                          value: [150, 150, '25552', '烫金'],
                          choose: false,
                          select_show: false,
                          select_data: [
                            {
                              name: '普通平烫',
                              value: [150, 150, '25552', '烫金'],
                            },
                            {
                              name: '浮雕烫',
                              value: [150, 150, '25551', '烫金'],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      container: 'tjys',
                      must: false,
                      data: [
                        {
                          type: 'select', name: '烫黄金', value: '烫金', choose: false, select_show: false, select_data: [
                            { name: '烫黄金', value: '烫金' },
                            { name: '烫哑金', value: '烫金' },
                            { name: '烫红金', value: '烫金' },
                            { name: '烫蓝金', value: '烫金' },
                            { name: '烫黑金', value: '烫金' },
                            { name: '烫银', value: '烫金' },
                            { name: '烫特殊颜色金', value: '烫金' },
                          ]
                        }
                      ]
                    },
                    {
                      container: ['jtx', 'jty', 'hjg', 'jtCl'],
                      must: false,
                      data: [
                        {
                          type: 'select',
                          custom2: true,
                          unit: 'mm',
                          name: '普通击凸版',
                          value: [120, 120, '击凸', '25548'],
                          choose: false,
                          select_show: false,
                          select_data: [
                            { name: '普通击凸版', value: [120, 120, '击凸', '25548'], },
                            { name: '加厚击凸版', value: [120, 120, '击凸', '25549'], },
                          ],
                        },
                      ],
                    },
                    {
                      container: 'hjg',
                      must: true,
                      reduce: true,
                      data: [
                        { type: 'default', name: '模切', value: '模切', choose: true },
                      ]
                    },
                    {
                      container: 'hjg',
                      must: true,
                      data: [
                        { type: 'default', name: '粘', value: '粘成品', choose: true },
                      ]
                    },
                    {
                      container: ['jdgs', 'hjg'],
                      must: false,
                      data: [
                        {
                          type: 'select', name: '装胶袋-10个(一袋)', value: ['10', '装胶袋'], choose: false, select_show: false, select_data: [

                            { name: '装胶袋-5个(一袋)', value: [5, '装胶袋'] },
                            { name: '装胶袋-6个(一袋)', value: [6, '装胶袋'] },
                            { name: '装胶袋-8个(一袋)', value: [8, '装胶袋'] },
                            { name: '装胶袋-10个(一袋)', value: [10, '装胶袋'] },
                          ]
                        },
                      ]
                    },
                    {
                      container: 'zhzd',
                      must: false,
                      data: [
                        {
                          type: 'select',
                          name: '扎红纸带-100个/扎',
                          value: '扎红纸带-100个/扎',
                          choose: false,
                          select_show: false,
                          select_data: [
                            { name: '扎红纸带-100个/扎', value: '100' },
                            { name: '扎红纸带-50个/扎', value: '50' },
                          ],
                        },
                      ]
                    },    
                ];
              }
            }
          }

          break;
        }
        case 'data_after': {
          const se = event.currentTarget.dataset.se;
          const select_index = event.currentTarget.dataset.select_index;
          let data = this.table[index][type];
          if (data[seq]['must'] && data[seq]['data'][se]['choose']) return;
          let in_data = data[seq]['data'];
          if (select_index !== undefined) {
            in_data[se]['name'] =
              in_data[se]['select_data'][select_index]['name'];
            in_data[se]['value'] =
              in_data[se]['select_data'][select_index]['value'];
          }

          if (data[seq]['must']) {
            // 当前行为-必选
            for (let i in in_data) {
              if (in_data[i]['choose']) {
                in_data[i]['choose'] = false;
                in_data[se]['choose'] = true;
                break;
              }
            }
          } else {
            // 当前行为-非必选
            if (in_data[se]['choose'] && select_index === undefined) {
              in_data[se]['choose'] = false;
            } else {
              for (let i in in_data) {
                if (in_data[i]['choose']) {
                  in_data[i]['choose'] = false;
                  break;
                }
              }
              in_data[se]['choose'] = true;
            }
          }
          if (
            data[seq].data[0].choose &&
            (data[seq].data[0].name == '普通平烫' ||
              data[seq].data[0].name == '浮雕烫')
          ) {
            for (let i in data) {
              if (data[i].container === 'tjys' && data[seq].data[0].name === '普通平烫') {
                data[i].data[0].choose = true;
              } else if (data[i].container === 'tjys1' && data[seq].data[0].name === '浮雕烫') {
                data[i].data[0].choose = true;
              }
            }
          } else if (
            !data[seq].data[0].choose &&
            (data[seq].data[0].name === '普通平烫' ||
              data[seq].data[0].name === '浮雕烫')
          ) {
            for (let i in data) {
              if (data[i].container === 'tjys' && data[seq].data[0].name == '普通平烫') {
                data[i].data[0].choose = false;
              } else if (data[i].container === 'tjys1' && data[seq].data[0].name == '浮雕烫') {
                data[i].data[0].choose = false;
              }
            }
          }
          if (data[seq].data[0].choose && data[seq].data[0].value === '烫金') {
            for (let i in data) {
              if (data[i].container[0] === 'tjx') {
                data[i].data[0].choose = true;
              }
            }
          } else if (
            !data[seq].data[0].choose &&
            data[seq].data[0].value === '烫金'
          ) {
            for (let i in data) {
              if (data[i].container[0] === 'tjx') {
                data[i].data[0].choose = false;
              }
            }
          }
          let id2 = 0;
          let id3 = 0;
          let leng = 0;
          if (
            this.table['p_leixing']['data'][0].choose &&
            this.table['p_zhizhangkezhong']['data_multi'][0].name === '双铜纸'
          ) {
            leng = 7;
            id2 = parseInt(seq) - 1;
            id3 = parseInt(seq) + 3;
          } else if (
            this.table['p_leixing']['data'][0].choose &&
            this.table['p_zhizhangkezhong']['data_multi'][0].name !== '双铜纸'
          ) {
            leng = 5;
            id2 = parseInt(seq) - 1;
            id3 = parseInt(seq) + 3;
          } else if (this.table['p_leixing']['data'][1].choose) {
            leng = 7;
            id2 = parseInt(seq) + 5;
            id3 = parseInt(seq) - 3;
          }

          break;
        }
        default: {
          return;
        }
      }
      // 整合规格参数，请求报价
      const params = this.func_tidyParams();
      this.$parent.func_quotation(this.pidd, params);
    },
    // 整理参数
    func_tidyParams() {
      let result = {};
      if (
        this.table['p_leixing']['data'][0].choose ||
        this.table['p_leixing']['data'][1].choose
      ) {
        //专版报价
        result = {
          need_QQoffer: false, //需QQ另行计价
          string: '专版红包-', //报价内容
          hjg: [],
          tjx: [],
          tjy: [],
          jban: ['0','0'],
          tangCl: [],
          TJTB: ['0','1'],
          SysCode: 'Web',
          pid: 3914,
          qid: 19,
          p: 0,
          byx: 2,
          // isdiy: 1,
          hjgzdycount: 10,
          sjlx: 2,
          labelVal: 0,
          Printer_Test: 0,
          ZXid: 0,
          BAY: 1,
          PSList: 0,
          TJTB1:1,
          tangJq: 0,
          zhiitemdj: 0,
          pzhiitemdj: 0,
          tban: 0,
          jpkezhong: 0,
          jphoudu: 1.45,
          jpdzx: 0,
          jdgs: 10,
          hjgother: 1,
          gvip: null,
          prh: '0', //常规印刷,精品印刷
          materialname: '',
          xfys: '中式',
        };
      } else if (this.table['p_leixing']['data'][2].choose) {
        result = {
          need_QQoffer: false, //需QQ另行计价
          string: '', //报价内容
          hjg: [],
          api: 'GetPrice2_v2020',
        };
      }

      for (let i in this.table) {
        // 当前行
        const line_name = i;
        // 当前行类型
        let line_type = this.table[i]['data']
          ? 'data'
          : this.table[i]['data_multi']
          ? 'data_multi'
          : this.table[i]['data_after']
          ? 'data_after'
          : false;
        if (!line_type) return;

        const data = this.table[i][line_type];
        switch (line_type) {
          // 面板一(普通)
          case 'data': {
            const container = this.table[i]['container'];
            if (!container) return;
            for (let j in data) {
              // 行中选中的块
              if (
                data[j]['choose'] &&
                (this.table['p_daomo']['data'][0].choose ||
                  this.table['p_daomo']['data'][1].choose)
              ) {
                if (data[j]['choose']) {
                  // 文字内容提示
                  if (line_name === 'p_yinshuashuliang') {
                    result['string'] += data[j]['value'] + '个-';
                    if (data[j].value < 100) {
                      data[j].value = 100;
                    }
                  } else if (line_name == 'p_kuanshu') {
                    result['string'] += data[j]['value'] + '款-';
                  } else if (
                    line_name === 'p_chengpinchicun' &&
                    data[j]['type'] === 'custom2'
                  ) {
                    const x = data[j]['value'][0];
                    const y = data[j]['value'][1];
                    result['string'] += data[j]['name'] + x + '×' + y + '-';
                  }else {
                    result['string'] += data[j]['name'] + '-';
                  }
                  // 常规处理
                  if (container.constructor['name'] === 'String') {
                    result[container] = data[j]['value'];
                    if (container == 'daomo') {
                      result.hjg.push(data[j]['name']);
                    }
                  } else if (container.constructor['name'] === 'Array') {
                    for (let c in container) {
                      result[container[c]] = data[j]['value'][c];
                    }
                  }

                  break;
                }
              }
            }
            break;
          }
          // 面板二(多行)
          case 'data_multi': {
            const container = this.table[i]['container'];
            if (!container) return;
            for (let c in container) {
              // 文字内容提示
              result['string'] += data[c]['name'] + '-';

              result[container[c]] = data[c]['value'];
            }
            break;
          }
          // 面板二(后道工序)
          case 'data_after': {
            for (let j in data) {
              const in_data = data[j]['data'];
              for (let k in in_data) {
                if (
                  this.table['p_daomo']['data'][0].choose ||
                  this.table['p_daomo']['data'][1].choose
                ) {
                  if (in_data[k]['choose']) {
                    // 文字内容提示
                    result['string'] += in_data[k]['name'] + '-';
                    const container = data[j]['container'];
                    if (!container) return;
                    if (container === 'hjg') {
                      result['hjg'].push(in_data[k]['value']);
                    } else if (container === 'tjx') {
                      result['tjx'].push(in_data[k]['value']);
                    } else if (container === 'tjy') {
                      result['tjy'].push(in_data[k]['value']);
                    } else if (container === 'tangCl') {
                      result['tangCl'].push(in_data[k]['value']);
                    }  else if (container.constructor['name'] === 'String') {
                      result[container] = in_data[k]['value'];
                    } else if (container.constructor['name'] === 'Array') {
                      for (let c in container) {
                        if (container[c] === 'hjg') {
                          result['hjg'].push(in_data[k]['value'][c]);
                        } if (container[c] === 'tjx') {
                          result['tjx'].push(in_data[k]['value'][c]);
                        }  if (container[c] === 'tjy') {
                          result['tjy'].push(in_data[k]['value'][c]);
                        }  if (container[c] === 'tangCl') {
                          result['tangCl'].push(in_data[k]['value'][c]);
                        } if (container[c] !== 'hjg' && container[c] !== 'tjx' && container[c] !== 'tjy' && container[c] !== 'tangCl') {
                          result[container[c]] = in_data[k]['value'][c];
                        }
                      }
                    } else if (
                      in_data[k]['name'] === '烫金' ||
                      in_data[k]['name'] === '击凸'
                    ) {
                      const x = in_data[k]['value'][0];
                      const y = in_data[k]['value'][1];
                      result['string'] +=
                        in_data[k]['name'] + x + '×' + y + '-';
                    } else if (
                      in_data[k]['name'].substring(0, 1) === '烫' &&
                      in_data[k]['custom2']
                    ) {
                      const x = in_data[k]['value'][0];
                      const y = in_data[k]['value'][1];
                      result['string'] +=
                        in_data[k]['name'] +
                        x +
                        '×' +
                        y +
                        in_data[k]['unit'] +
                        '-';
                    } 
                    break;
                  }
                }
              }
            }
            break;
          }
          default:
            return;
        }
      }
      if (
        this.table['p_leixing']['data'][0].choose ||
        this.table['p_leixing']['data'][1].choose
      ) {
        //专版报价
        this.pidd = 'zhuanbanhongbao';
      } else if (this.table['p_leixing']['data'][2].choose) {
        this.pidd = 'pidredenv_hbhb';
      }
      if (result['string'].endsWith('-')) {
        result['string'] = result['string'].substring(
          0,
          result['string'].length - 1
        );
      }
      if (!this.table['p_leixing']['data'][2].choose) {
        result.materialname = this.table.p_zhizhangkezhong.data_multi[0].value;
      }
      if (result.leixing == '特种纸烫金红包') {
        result.leixing = '现货红包';
        if (this.pidd === 'pidredenv_hbhb') {
          result.cailiao =
            this.table.p_zhizhangkezhong['data_multi'][1].name +
            this.table.p_zhizhangkezhong['data_multi'][0].name;
        }
      }
      if (result.chichunstr.indexOf('展开尺寸') >= 0) {
        result.chichunstr = '展开尺寸:' + result.xx + 'X' + result.yy;
        result.isdiy = 1;
      }
      if (result.cailiao == '1' && result.yongzhi == '157') {
        result.cailiao = '20672';
      }
      if (result.bmcl == '8656') {
        result.hjgzdy4 = '8656';
      } else if (result.bmcl == '8657') {
        result.hjgzdy5 = '8657';
      } else if (result.bmcl == '4292') {
        result.hjgzdy1 = '4292';
      }
      if (result.tangCl && result.tangCl.includes('25552') && result.chichunstr === '大号(88*165)') {
        result.tjx.push('150');
        result.tjy.push('150');
      } else if (
        result.tangCl &&
        result.tangCl.includes('25552') &&
        result.chichunstr === '中号(80*120)'
      ) {
        result.tjx.push('120');
        result.tjy.push('120');
      } else if (result.tangCl &&
        result.tangCl.includes('25552') &&
        result.chichunstr.indexOf('展开尺寸')>=0){
        const xValue = Number(result.xx) - 50;
        result.tjx.push(String(xValue < 0 ? 0 : xValue));
        const yValue = Number(result.yy) - 50;
        result.tjy.push(String(yValue < 0 ? 0 : yValue));
      }

      result.hjg = [...new Set(result.hjg)]; 
      return result;
    },
  },
  mounted() {},
};
</script>
<style src="@/style/orderProduct.css"></style>



// WEBPACK FOOTER //
// src/pages/order/v2020/hongbao.vue